import React, { useEffect, useState } from 'react';
import {
  dispatchSpecialOffersDraftsCommand,
  DraftsState,
  loadDraftsState,
  SPECIAL_OFFERS_DRAFTS_SYNC_EVENT,
} from '../SpecialOffersCalculator/specialOffersDraftStorage';

const SpecialOffersTopbarDrafts: React.FC = () => {
  const [draftsState, setDraftsState] = useState<DraftsState>(() => loadDraftsState());

  useEffect(() => {
    const syncFromStorage = () => {
      setDraftsState(loadDraftsState());
    };

    const handleSync = (event: Event) => {
      const customEvent = event as CustomEvent<DraftsState>;
      if (customEvent.detail) {
        setDraftsState(customEvent.detail);
        return;
      }

      syncFromStorage();
    };

    window.addEventListener(SPECIAL_OFFERS_DRAFTS_SYNC_EVENT, handleSync as EventListener);
    window.addEventListener('storage', syncFromStorage);

    return () => {
      window.removeEventListener(SPECIAL_OFFERS_DRAFTS_SYNC_EVENT, handleSync as EventListener);
      window.removeEventListener('storage', syncFromStorage);
    };
  }, []);

  return (
    <div className="app-pro-topbar-drafts" aria-label="\u041f\u0440\u043e\u0444\u0438\u043b\u0438 \u0440\u0430\u0441\u0441\u044b\u043b\u043e\u043a">
      {draftsState.drafts.map((draft, index) => {
        const isActive = draft.id === draftsState.activeDraftId;

        return (
          <div key={draft.id} className="app-pro-topbar-draft-item">
            <button
              type="button"
              className={`app-pro-topbar-draft-btn ${isActive ? 'active' : ''}`}
              onClick={() => dispatchSpecialOffersDraftsCommand({ type: 'select', draftId: draft.id })}
              aria-label={`\u041f\u0440\u043e\u0444\u0438\u043b\u044c \u0440\u0430\u0441\u0441\u044b\u043b\u043a\u0438 ${index + 1}`}
              title={`\u041f\u0440\u043e\u0444\u0438\u043b\u044c ${index + 1}`}
            >
              {index + 1}
            </button>
            <button
              type="button"
              className="app-pro-topbar-draft-remove"
              onClick={() => dispatchSpecialOffersDraftsCommand({ type: 'delete', draftId: draft.id })}
              aria-label={`\u0423\u0434\u0430\u043b\u0438\u0442\u044c \u043f\u0440\u043e\u0444\u0438\u043b\u044c ${index + 1}`}
              title={`\u0423\u0434\u0430\u043b\u0438\u0442\u044c \u043f\u0440\u043e\u0444\u0438\u043b\u044c ${index + 1}`}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        );
      })}

      <button
        type="button"
        className="app-pro-topbar-draft-btn app-pro-topbar-draft-add"
        onClick={() => dispatchSpecialOffersDraftsCommand({ type: 'create' })}
        aria-label="\u0421\u043e\u0437\u0434\u0430\u0442\u044c \u043d\u043e\u0432\u0443\u044e \u0440\u0430\u0441\u0441\u044b\u043b\u043a\u0443"
        title="\u0421\u043e\u0437\u0434\u0430\u0442\u044c \u043d\u043e\u0432\u0443\u044e \u0440\u0430\u0441\u0441\u044b\u043b\u043a\u0443"
      >
        <i className="fas fa-plus" />
      </button>
    </div>
  );
};

export default SpecialOffersTopbarDrafts;
